import React, { useEffect, useRef } from 'react';
import { Text, Animated, StyleSheet, Platform, View } from 'react-native';
import FullscreenSafeModal from './FullscreenSafeModal';

export const Toast = ({ message, type = 'success', onHide, hostRef = null }) => {
  const translateY = useRef(new Animated.Value(-100)).current;

  useEffect(() => {
    translateY.setValue(-100);

    Animated.spring(translateY, {
      toValue: 0,
      useNativeDriver: true,
      tension: 80,
      friction: 10,
    }).start();

    const timer = setTimeout(() => {
      Animated.timing(translateY, {
        toValue: -100,
        duration: 300,
        useNativeDriver: true,
      }).start(() => {
        if (onHide) onHide();
      });
    }, 3000);

    return () => clearTimeout(timer);
  }, [message, onHide, translateY]);

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return '#4caf50';
      case 'error':
        return '#f44336';
      case 'warning':
        return '#ff9800';
      default:
        return '#4caf50';
    }
  };

  if (!message) return null;

  return (
    <FullscreenSafeModal
      visible
      transparent
      animationType="none"
      statusBarTranslucent
      hostRef={hostRef}
      onRequestClose={() => onHide?.()}
    >
      <View style={styles.overlay} pointerEvents="box-none">
        <Animated.View
          style={[
            styles.container,
            { transform: [{ translateY }], backgroundColor: getBackgroundColor() },
          ]}
          pointerEvents="none"
        >
          <Text style={styles.text}>{message}</Text>
        </Animated.View>
      </View>
    </FullscreenSafeModal>
  );
};

const styles = StyleSheet.create({
    overlay: {
      flex: 1,
      alignItems: 'center',
      paddingTop: Platform.OS === 'web' ? 24 : 48,
      backgroundColor: 'transparent',
      ...(Platform.OS === 'web' ? { ...StyleSheet.absoluteFillObject, height: '100%', width: '100%' } : {}),
    },
  container: {
    width: 300,
    maxWidth: '90%',
    padding: 16,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 10,
  },
  text: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
    fontFamily: 'VastagoGrotesk',
  },
});
